export default __webpack_public_path__ + "static/media/ghybrid.0f96e3ae.png";